<template>
  <b-table
    :data="tagCategories"
    :striped="true"
    :narrowed="true"
    :hoverable="true"
    :sort-icon="'angle-up'"
    paginated
    per-page="20"
  >
    <b-table-column
      :label="$t('compCoreTagCategoryTable.label-1')"
      field="name"
      sortable
      v-slot="props"
    >
      {{ props.row.name }}
    </b-table-column>
    <b-table-column
      :label="$t('compCoreTagCategoryTable.label-2')"
      field="description"
      sortable
      v-slot="props"
    >
      <span v-if="props.row.description">{{ props.row.description }}</span>
      <span v-else>-</span>
    </b-table-column>
    <b-table-column
      :label="$t('compCoreTagCategoryTable.label-3')"
      field="tags"
      sortable
      v-slot="props"
    >
      <b-tooltip
        :label="$t('compCoreTagCategoryTable.tooltip-geotag')"
        type="is-black"
        multilined
      >
        <b-icon icon="map-marker" v-if="props.row.isGeoTag" />
      </b-tooltip>
      <my-tag-list :tags="props.row.tags" :limit="6" />
    </b-table-column>

    <b-table-column width="120" v-slot="props">
      <div class="panel-block">
        <b-tooltip :label="$t('edit')" type="is-black">
          <b-button
            size="is-small"
            icon-left="pencil"
            @click="edit(props.row)"
          />
        </b-tooltip>
        <b-tooltip :label="$t('delete')" type="is-black">
          <b-button size="is-small" icon-left="trash" @click="del(props.row)" />
        </b-tooltip>
      </div>
    </b-table-column>
    <section slot="empty" class="section">
      <div class="content has-text-grey has-text-centered">
        <p>
          <i class="fa fa-ban" style="font-size: 64px"></i>
        </p>
        <p>{{ $t('compCoreTagCategoryTable.no-tag') }}</p>
      </div>
    </section>
  </b-table>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'

export default {
  name: 'TagCategoryTable',
  setup () {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  components: {
    'my-tag-list': () => import('@/components/core/MyTagList.vue')
  },
  computed: {
    tagCategories: function () {
      return this.adminStore.allTagCategories
    }
  },
  methods: {
    edit: function (category) {
      this.$emit('edit', category)
    },
    del: function (category) {
      let self = this
      this.$buefy.dialog.confirm({
        title: self.$t('compCoreTagCategoryTable.title-1'),
        message: self.$t('compCoreTagCategoryTable.info-1'),
        confirmText: self.$t('delete'),
        cancelText: self.$t('cancel'),
        canCancel: ['escape', 'button', 'outside'],
        onConfirm: function () {
          self.adminStore.deleteTagCategory(category.id)
        }
      })
    }
  }
}
</script>
